/**
 * @param {string} text
 * @param {number} length
 * @param {string|string} suffix
 * @return {string}
 */
export function truncateText(text, length, suffix) {
  if (text.length > length) {
    return text.substring(0, length) + (suffix || '...');
  } else {
    return text;
  }
}

/**
 * @param {string} text
 * @param {{
 *   start?: number,
 *   maxLength?: number,
 *   startOffset?: number,
 *   endOffset?: number,
 *   suffix?: string,
 * }} [options]
 * @returns {string}
 */
export function truncateString(text, options) {
  if (text.length > options.maxLength) {
    if (!options?.endOffset) {
      return text.substring(options.start || 0, options.maxLength) + (options.suffix || '...');
    }

    return text.slice(options.start || 0, options.startOffset || 7) + '...' + text.slice(-options.endOffset || 7);
  } else {
    return text;
  }
}

/**
 * Convert video and audio bitrate to human-readable format and round it without decimals.
 *
 * @param {number} bitrate
 * @returns {string}
 */
export function convertBitrate(bitrate) {
  if (bitrate < 1000) {
    return bitrate + ' bps';
  } else if (bitrate < 1000000) {
    return Math.round(bitrate / 1000) + ' kbps';
  } else {
    return Math.round(bitrate / 1000000) + ' Mbps';
  }
}

/**
 * Round the number to the upper value defining the number of decimals. It could also be rounded to number without decimals
 *
 * @param {number} number
 * @param {number} decimals
 * @returns {string}
 */
export function roundNumber(number, decimals) {
  return number.toFixed(decimals);
}

/**
 * Convert video and audio duration to human-readable format
 *
 * @param {number} duration
 * @returns {string}
 */
export function formatDuration(duration) {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration - hours * 3600) / 60);
  const seconds = Math.floor(duration - hours * 3600 - minutes * 60);
  return hours + 'h ' + minutes + 'm ' + seconds + 's';
}
